import { useModal } from '@skillarea/lib-frontend';
import { useTranslation } from 'react-i18next';

import { ChestPromptModal } from '~/components/ChestPromptModal/ChestPromptModal';

export function ChestAlreadyOpenedModal() {
  const { t } = useTranslation('modals');
  const { closeModal } = useModal();
  const title = t('chestAlreadyOpened.title');

  return (
    <ChestPromptModal
      ctaLabel={t('common.ok')}
      description={t('chestAlreadyOpened.message')}
      heading={title}
      onCta={() => closeModal()}
      testId="chest-modal-opened"
      title={title}
    />
  );
}
